import React from 'react';
import axios from "../../../containers/api";
import {showCatchError, toEnglishNumbers} from "../../../helpers/Utils";
import {Button, CardBody, Input, Row, Alert,FormGroup, Label} from "reactstrap";
 
import {Colxx} from "../../../components/common/CustomBootstrap";

class ChangePassModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            errors: [],
            UserName: this.props.UserName,
            
            Password: "",
           
          
            
           
        }
    }

   
    componentDidMount() {
        
    }
   

    validate = () => {
        let error = [];
        if (this.state.Password === null || this.state.Password === '') {
            error.push('وارد كردن رمز کاربری الزامي میباشد!');
        }
        if (this.state.Password.length < 6) {
            error.push('وارد كردن حداقل 6 كاراكتر برای رمز كاربري الزامي ميباشد');
        }
        

        this.setState({errors: error});
        if (error.length === 0) {
            this.changePassword();
        } else {
            this.props.showAlert("لطفا تمامی اطلاعات درخواست شده را به درستی وارد کنید!", "error");
        }
    };
  
    changePassword = () => {
         
        let model = {
            Username: toEnglishNumbers(this.state.UserName),
            Password: toEnglishNumbers(this.state.Password),
        }
        this.props.showSpinner();
        axios.put('/api/v1/users/admin-change-pass', model)

            .then((res) => {
                this.props.hideSpinner();
                this.props.showAlert(res.data.message, "success");
                
            })
            .catch((error) => {
                this.props.hideSpinner();
                console.log(error.response);
                this.props.showAlert(showCatchError(error), "error");
            });
    };
    
    render() {
        return (
            <Row className="d-flex justify-content-center">
                <Colxx md="10" xxs="12">
                    <CardBody className="d-flex flex-column">
                        <div className="d-flex flex-md-row flex-column flex-wrap">
                            

                            <FormGroup className="w-md-25 w-100 px-1">
                                <Label>نام کاربری</Label>
                                <Input value={ this.state.UserName} readOnly/>
                            </FormGroup>
                            <FormGroup className="w-md-25 w-100 px-1">
                                <Label>رمز کاربری</Label>
                                <Input value={this.state.Password} maxLength={100}
                                    onChange={(e) => this.setState({ Password: e.target.value })} />
                            </FormGroup>
                            

                           
                        </div>

                        {this.state.errors.length === 0 ?
                            null
                            :
                            <div>
                                {(this.state.errors.map((error, i) => {
                                    return (
                                        <Alert color="danger" key={i}>{error}</Alert>
                                    )
                                }))}
                            </div>
                        }

                        <div className="d-flex mt-2 justify-content-center">
                            <FormGroup className="text-center">
                                <Button color="primary" className="btn-lg mx-2" onClick={this.validate}>
                                    ذخیره
                                </Button>
                            </FormGroup>
                        </div>
                    </CardBody>
                </Colxx>
            </Row>
        );
    }
}

export default ChangePassModal;